<template>
  <v-card>
    <v-flex>
      <span class="login-form">
        <v-card-text>
          <img src="/static/img/avatar.png" class="avatar" alt="Avatar" />
          <h2>{{ mainTitle }}</h2>
          <form>
            <v-text-field
              v-model="loginForm.email"
              :label="labels.email"
              type="email"
              :error-messages="errors.collect('email')"
              v-validate="'required|email'"
              data-vv-name="email"
              :data-vv-as="labels.email"
              :disabled="msalLoading"
            ></v-text-field>
            <v-text-field
              v-model="loginForm.password"
              :label="labels.password"
              :type="showPassword ? 'text' : 'password'"
              @focus="pwdType = 'password'"
              :error-messages="errors.collect('password')"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (showPassword = !showPassword)"
              v-validate="'required'"
              data-vv-name="password"
              :data-vv-as="labels.password"
              :disabled="msalLoading"
            ></v-text-field>
            <!-- <v-text-field v-model="loginForm.password" type="hidden" v-show="false" readonly></v-text-field>
            <v-text-field v-model="loginForm.password3" type="password" v-show="false" readonly></v-text-field> -->
            <!-- <v-checkbox
              v-model="showPassword"
              :label="labels.showPassword"
              :error-messages="errors.collect('showPassword')"
              data-vv-name="showPassword"
              type="checkbox"
              :data-vv-as="labels.rememberMe"
            ></v-checkbox> -->
            <v-checkbox
              v-model="loginForm.rememberMe"
              :label="labels.rememberMe"
              :error-messages="errors.collect('rememberMe')"
              data-vv-name="rememberMe"
              type="checkbox"
              :data-vv-as="labels.rememberMe"
            ></v-checkbox>
            <v-btn color="primary" type="submit" @click.prevent="doLogin" :loading="loading || msalLoading">Login</v-btn>
            <v-btn text :to="{ name: 'forgetPassword' }">Forget password?</v-btn>
          </form>
        </v-card-text>
        <v-divider v-if="isMSssoEnabled"></v-divider>
        <v-card-actions v-if="isMSssoEnabled" class="pa-5 justify-center">
          <v-btn :loading="msalLoading" block @click="doMsSSOLogin" :disabled="loading">
            <img src="@/assets/microsoft.png" alt="Upload icon" style="width: 24px; height: 24px; margin-right: 8px;" />
            Login with Microsoft
          </v-btn>
        </v-card-actions>
      </span>
    </v-flex>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { setCookie, getCookie } from '@/utils/cookie'

export default {
  data() {
    return {
      labels: {
        email: 'Email*',
        password: 'Password*',
        rememberMe: 'Remember me?',
        showPassword: 'Show Password'
      },
      loginForm: {
        email: '',
        password: '',
        password2: '',
        password3: '',
        rememberMe: false
      },
      loginMenu: [
        {
          title: 'Submit Help Ticket',
          action: 'submitHelp'
        }
      ],
      loading: false,
      pwdType: 'search',
      showPassword: false
    }
  },
  computed: {
    mainTitle() {
      return this.$store.state.app.projectTitleLong
    },
    isMSssoEnabled() {
      return this.$store.state.app.dataMap.msSSOEnabled
    },
    msalLoading() {
      return this.$store.state.token.msalLoading
    }
  },
  methods: {
    handleMenu(name) {
      switch (name) {
        case 'submitHelp':
          this.submitHelp()
          break
      }
    },
    submitHelp() {
      this.$toast.warning('Features not ready')
    },
    doLogin() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          const apiURI = this.$store.state.app.baseMenu.login
          if (apiURI) {
            this.loading = true
            this.$http
              .post(apiURI, this.loginForm)
              .then(response => {
                // Process Login Form
                this.$store.dispatch('processLoginForm', response).then(() => {
                  // Redirect to dashboard
                  // this.notify(data)
                  this.loading = false
                  this.$router.push({ name: 'dashboard' })

                  // Successful check rembme to setcookie
                  // AES.encrypt(JSON.stringify(state).toString(), mavKey)
                  if (this.loginForm.rememberMe) {
                    setCookie('username', this.loginForm.email, 30)
                  } else {
                    setCookie('username', '')
                  }
                })
              })
              .catch(error => {
                const { data } = error.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                  this.$toast.error(data.messages[0].message)
                }
                this.loginForm.password = ''
                this.loading = false
              })
          } else {
            this.errorMessage('Error encountered')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doMsSSOLogin() {
      await this.$msal.login()
    }
  },
  async created() {
    if (getCookie('username')) {
      this.loginForm.email = getCookie('username')
      this.loginForm.rememberMe = true
    }
    if (this.isMSssoEnabled) {
      await this.$msal.ssoauth()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
.disclaimerText {
  color: #666;
}
.login-form {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  min-width: 400px;
  min-height: 500px;
  padding: 80px 40px;
  box-sizing: border-box;
  background: hsla(0, 0%, 100%, 0.4);
}
.avatar {
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  top: calc(-80px / 2);
  left: calc(50% - 40px);
}
.login-form h2 {
  margin: 0;
  padding: 0 0 20px;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
}
</style>
